import { WintSuperkollAPIModelFinancialReport } from "wint-api-client/dist/types";
import { TableEnums } from "models/enums";
import { AccountingEnums } from "models/enums";
import { IconDefinitionConstants } from "utils/constants";

const FinancialReportHelper = {
  getResultReportRowIcon: (row: WintSuperkollAPIModelFinancialReport.FinancialReportRow) => {
    switch (Number(row.id)) {
      case AccountingEnums.AccountingCategoryType.Revenue:
        return IconDefinitionConstants.WIncome2;
      case AccountingEnums.AccountingCategoryType.DirectCosts:
        return IconDefinitionConstants.WCosts2;
      case AccountingEnums.AccountingCategoryType.Staff:
        return IconDefinitionConstants.WUser;
      case AccountingEnums.AccountingCategoryType.Overhead:
        return IconDefinitionConstants.WMoney;
      case AccountingEnums.AccountingCategoryType.Impairments:
        return IconDefinitionConstants.WReportDown;
      case AccountingEnums.AccountingCategoryType.Depreciation:
        return IconDefinitionConstants.WReportDown;
      case AccountingEnums.AccountingCategoryType.FinancialItems:
        return IconDefinitionConstants.WBank;
      case AccountingEnums.AccountingCategoryType.ExtraordinaryItems:
        return IconDefinitionConstants.WMoney;
      case AccountingEnums.AccountingCategoryType.Allocations:
        return IconDefinitionConstants.WMoney;
      case AccountingEnums.AccountingCategoryType.Taxes:
        return IconDefinitionConstants.WMoney;
      case AccountingEnums.AccountingCategoryType.RecordsOfInvestigation:
        return IconDefinitionConstants.WList;
      default:
        return IconDefinitionConstants.WList;
    }
  },

  getMonthlyResultReportRowIcon: (row: WintSuperkollAPIModelFinancialReport.FinancialReportRow) => {
    switch (row.id) {
      case AccountingEnums.AccountingCategoryType[AccountingEnums.AccountingCategoryType.Revenue]:
        return IconDefinitionConstants.WIncome2;
      case AccountingEnums.AccountingCategoryType[AccountingEnums.AccountingCategoryType.DirectCosts]:
        return IconDefinitionConstants.WCosts2;
      case AccountingEnums.AccountingCategoryType[AccountingEnums.AccountingCategoryType.Staff]:
        return IconDefinitionConstants.WUser;
      case AccountingEnums.AccountingCategoryType[AccountingEnums.AccountingCategoryType.Overhead]:
        return IconDefinitionConstants.WMoney;
      case AccountingEnums.AccountingCategoryType[AccountingEnums.AccountingCategoryType.Impairments]:
        return IconDefinitionConstants.WReportDown;
      case AccountingEnums.AccountingCategoryType[AccountingEnums.AccountingCategoryType.Depreciation]:
        return IconDefinitionConstants.WReportDown;
      case AccountingEnums.AccountingCategoryType[AccountingEnums.AccountingCategoryType.FinancialItems]:
        return IconDefinitionConstants.WBank;
      case AccountingEnums.AccountingCategoryType[AccountingEnums.AccountingCategoryType.ExtraordinaryItems]:
        return IconDefinitionConstants.WMoney;
      case AccountingEnums.AccountingCategoryType[AccountingEnums.AccountingCategoryType.Allocations]:
        return IconDefinitionConstants.WMoney;
      case AccountingEnums.AccountingCategoryType[AccountingEnums.AccountingCategoryType.Taxes]:
        return IconDefinitionConstants.WMoney;
      case AccountingEnums.AccountingCategoryType[AccountingEnums.AccountingCategoryType.RecordsOfInvestigation]:
        return IconDefinitionConstants.WList;
      default:
        return IconDefinitionConstants.WList;
    }
  },

  getBalanceReportRowIcon: (row: WintSuperkollAPIModelFinancialReport.FinancialReportRow) => {
    switch (Number(row.id)) {
      case AccountingEnums.AccountingCategoryType.FixedAssets:
        return IconDefinitionConstants.WHouse;
      case AccountingEnums.AccountingCategoryType.FinancialAssets:
        return IconDefinitionConstants.WBox;
      case AccountingEnums.AccountingCategoryType.CurrentAssets:
        return IconDefinitionConstants.WBox;
      case AccountingEnums.AccountingCategoryType.Equity:
        return IconDefinitionConstants.WIncome2;
      case AccountingEnums.AccountingCategoryType.SumNotBookedResultsInBalanceReport:
        return IconDefinitionConstants.WMoney;
      case AccountingEnums.AccountingCategoryType.UntaxedReserves:
        return IconDefinitionConstants.WMoney;
      case AccountingEnums.AccountingCategoryType.Provisions:
        return IconDefinitionConstants.WMoney;
      case AccountingEnums.AccountingCategoryType.LongTermLiabilities:
        return IconDefinitionConstants.WCosts;
      case AccountingEnums.AccountingCategoryType.CurrentLiabilities:
        return IconDefinitionConstants.WMoneyBag;
      case AccountingEnums.AccountingCategoryType.RecordsOfInvestigation:
        return IconDefinitionConstants.WList;
      default:
        return IconDefinitionConstants.WList;
    }
  },

  getMonthlyBalanceReportRowIcon: (row: WintSuperkollAPIModelFinancialReport.FinancialReportRow) => {
    switch (row.id) {
      case AccountingEnums.AccountingCategoryType[AccountingEnums.AccountingCategoryType.FixedAssets]:
        return IconDefinitionConstants.WHouse;
      case AccountingEnums.AccountingCategoryType[AccountingEnums.AccountingCategoryType.FinancialAssets]:
        return IconDefinitionConstants.WBox;
      case AccountingEnums.AccountingCategoryType[AccountingEnums.AccountingCategoryType.CurrentAssets]:
        return IconDefinitionConstants.WBox;
      case AccountingEnums.AccountingCategoryType[AccountingEnums.AccountingCategoryType.Equity]:
        return IconDefinitionConstants.WIncome2;
      case AccountingEnums.AccountingCategoryType[
        AccountingEnums.AccountingCategoryType.SumNotBookedResultsInBalanceReport
      ]:
        return IconDefinitionConstants.WMoney;
      case AccountingEnums.AccountingCategoryType[AccountingEnums.AccountingCategoryType.UntaxedReserves]:
        return IconDefinitionConstants.WMoney;
      case AccountingEnums.AccountingCategoryType[AccountingEnums.AccountingCategoryType.Provisions]:
        return IconDefinitionConstants.WMoney;
      case AccountingEnums.AccountingCategoryType[AccountingEnums.AccountingCategoryType.LongTermLiabilities]:
        return IconDefinitionConstants.WCosts;
      case AccountingEnums.AccountingCategoryType[AccountingEnums.AccountingCategoryType.CurrentLiabilities]:
        return IconDefinitionConstants.WMoneyBag;
      case AccountingEnums.AccountingCategoryType[AccountingEnums.AccountingCategoryType.RecordsOfInvestigation]:
        return IconDefinitionConstants.WList;
      default:
        return IconDefinitionConstants.WList;
    }
  },

  /**
   * The transaction category a report row points at, as a number.
   *
   * Category rows normally carry the numeric `AccountingCategoryType`, but the monthly and
   * tag-based reports have historically sent the enum name ("Revenue"). `Number("Revenue")` is
   * NaN, which reaches the API as an empty `categoryId` and silently disables the filter instead
   * of failing, so the drill-down returns the whole ledger. Accept both forms, and return
   * undefined for anything else (account and dimension rows carry a guid).
   */
  getCategoryId: (row?: WintSuperkollAPIModelFinancialReport.FinancialReportRow): number | undefined => {
    // Loose null check on purpose: the API is Newtonsoft-backed and serialises title and spacer
    // rows as `id: null`, which a strict undefined check would let through into `.trim()`.
    if (row?.id == null || row.id.trim() === "") return undefined;

    const numericId = Number(row.id);
    if (Number.isFinite(numericId)) return numericId;

    const idFromName =
      AccountingEnums.AccountingCategoryType[row.id as keyof typeof AccountingEnums.AccountingCategoryType];
    return typeof idFromName === "number" ? idFromName : undefined;
  },

  getResultReportRowDisplayType: (row: WintSuperkollAPIModelFinancialReport.FinancialReportRow) => {
    return row.isAccount
      ? TableEnums.RowDisplayType.Leaf
      : row.isDimension && row.type === WintSuperkollAPIModelFinancialReport.FinancialReportRowType.Title
        ? TableEnums.RowDisplayType.DimensionTitle
        : row.isDimension
          ? TableEnums.RowDisplayType.Dimension
          : row.type === WintSuperkollAPIModelFinancialReport.FinancialReportRowType.SumSmall
            ? TableEnums.RowDisplayType.SumSmall
            : row.type === WintSuperkollAPIModelFinancialReport.FinancialReportRowType.Sum
              ? TableEnums.RowDisplayType.Sum
              : row.type === WintSuperkollAPIModelFinancialReport.FinancialReportRowType.Title
                ? TableEnums.RowDisplayType.Title
                : row.type === WintSuperkollAPIModelFinancialReport.FinancialReportRowType.Empty
                  ? TableEnums.RowDisplayType.Empty
                  : undefined;
  },

  getBalanceReportRowDisplayType: (row: WintSuperkollAPIModelFinancialReport.FinancialReportRow) => {
    return row.isAccount
      ? undefined
      : row.type === WintSuperkollAPIModelFinancialReport.FinancialReportRowType.SumSmall ||
          row.type === WintSuperkollAPIModelFinancialReport.FinancialReportRowType.Sum
        ? TableEnums.RowDisplayType.SumSmall
        : row.type === WintSuperkollAPIModelFinancialReport.FinancialReportRowType.Title
          ? TableEnums.RowDisplayType.Title
          : row.type === WintSuperkollAPIModelFinancialReport.FinancialReportRowType.Empty
            ? TableEnums.RowDisplayType.Empty
            : undefined;
  },
};

export default FinancialReportHelper;
